import { render } from "./AboutYourself.vue?vue&type=template&id=e5d3b1c8"
import script from "./AboutYourself.vue?vue&type=script&lang=js"
export * from "./AboutYourself.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__